/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsdescription1Inputs */

const en_earningsdescription1 = /** @type {(inputs: Earningsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What your tickets bring in and when the money reaches your account.`)
};

const de_earningsdescription1 = /** @type {(inputs: Earningsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was deine Tickets einbringen und wann das Geld auf deinem Konto ist.`)
};

/**
* | output |
* | --- |
* | "What your tickets bring in and when the money reaches your account." |
*
* @param {Earningsdescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsdescription1 = /** @type {((inputs?: Earningsdescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsdescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsdescription1(inputs)
	return de_earningsdescription1(inputs)
});
export { earningsdescription1 as "earningsDescription" }